import Axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { APIError, Segment } from "src/types";

export type SegmentMutationData = Omit<Segment, "segmentId">;
export type SegmentCreateMutationData = SegmentMutationData & {
  lineString_frontendSrid: string;
};

export function useSegmentCreateMutation(scenarioId: number | string) {
  async function mutationFn(scenarioId: number | string, data: SegmentCreateMutationData) {
    const url = `/planning-api/scenarios/${scenarioId}/segments`;
    const response = await Axios.post<{ id: number } | { id: number }[]>(url, data);
    return response.data;
  }

  return useMutation<{ id: number } | { id: number }[], AxiosError<APIError[]>, SegmentCreateMutationData>(
    (values: SegmentCreateMutationData) => mutationFn(scenarioId, values)
  );
}
